import {createRoot} from 'react-dom/client';
import {StrictMode} from "react";
import ContragentList from "../components/contragents/ContragentList";
document.addEventListener('DOMContentLoaded', function () {

    const contragentForm = document.getElementById('createContragent');
    if (contragentForm) {
        createRoot(contragentForm).render(<StrictMode><ContragentList/></StrictMode>);
    }
})